<div class="mat-body-2">
	<h1>TWILIGHT RACES</h1>
	<h3>Steinhuder Meer Vereine bieten Regatta-Serie und Clubabende für Alle</h3>

	<p>Der Regattasport erscheint vielen als “geschlossene Gesellschaft“. Große Yachten segeln in elitären Clubs unter
		Ausschluss der Öffentlichkeit. Es fallen Begriffe wie VMG, Mastfall, Fockaffe, Linksdreher… und wer am Ende
		gewonnen
		hat, ist nicht immer allen klar. Das dies definitiv nicht so ist, wollen die Segelclubs am Steinhuder Meer mit
		der
		TWILIGHT RACE Serie unter Beweis stellen.</p>

	<p>“Regattasegeln sollte einfach sein“ so Niels Hentschel, einer der Ausrichter vom Schaumburg Lippischen
		Seglerverein e.V.
		“und möglichst viele Menschen bei Sport und Unterhaltung zusammenbringen“. Am schönsten sei es, so der Sportwart
		vom
		SLSV weiter, wenn man nach Feierabend und kurz vor Sonnenuntergang noch eine Runde segeln gehen kann, um im
		Anschluss
		mit Freunden einen Sundowner auf einem der Clubgrundstücke direkt am Steinhuder Meer zu trinken.</p>

	<p>Die TWILIGHT RACE Serie bietet an sieben Donnerstagen und zwei Samstagen von April bis September die Möglichkeit
		zur
		Teilnahme an einer Wettfahrt und einem Abend in einem der teilnehmenden Vereine an.</p>

	<p>Für die Donnerstags- Wettfahrten muss man lediglich kurz vor dem Start um 18:00 h mit einem am Steinhuder Meer
		zugelassenen Einrumpf-Segelboot auf dem Steinhuder Meer sein. Die Position des Startbootes wird über einen
		Nachrichtendienst geteilt, gewertet wird nach der einfachen Vergütungsformel YARDSTICK - so kann der
		High-Tech-Racer
		gegen das Familien-Dickschiff segeln und in einer gemeinsamen Ergebnisliste gewertet werden.</p>

	<p>Im Anschluss laden die jeweils ausrichtenden Vereine Seglerverein Großenheidorn/ SVG, Baltische
		Seglervereinigung/ BSV,
		Yachtclub Steinhuder Meer/ YSTM und Schaumburg Lippischer Seglerverein/ SLSV in Ihre bewirteten Clubhäuser ein.
		Auch
		ohne eine Mitgliedschaft besteht hier die Möglichkeit in das Clubleben hineinzuschnuppern, sich von den
		jeweiligen
		Ökonomen bewirten zu lassen oder gemeinsam mit weiteren Teilnehmern bei einem Sundowner den schönsten
		Sonnenuntergang
		der Region am Steinhuder Meer zu genießen - voll und ganz im TWILIGHT!</p>

	<p>Zusätzlich ist die Serie mit jeweils zwei Wettfahrten in die beliebte Veranstaltung SAIL and GOLF am Samstag den
		28.
		Juni, sowie die Abschlussveranstaltung mit Siegerehrung und Party im Schaumburg Lippischen Seglerverein am
		Samstag 06.
		September 2025 integriert. Weitere Informationen unter <a href="www.manage2sail.com/twilight25"
			target="blank">www.manage2sail.com/twilight25</a>.</p>

	<div style="margin-top:32px;">
		<img src="assets/other/twilight-races-2025.png" alt="Twilight Races 2025" style="width:100%;">
	</div>
</div>